import { Component } from '@angular/core';

@Component({
    selector: 'marketing',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class MarketingComponent {}
